import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  }
}))
